module.exports = __webpack_public_path__ + "img/transactional-sample.df7d658e.jpeg";